import ChartBar from "components/chart/ChartBar";
import ChartPie from "components/chart/ChartPie"
import { ChartBarModel } from "model/chart/ChartBarModel";
import { ChartPieModel } from "model/chart/ChartPieModel"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import SuprimentosDashboardService from "service/suprimentos/SuprimentosDashboardService";

const suprimentosDashboardService = new SuprimentosDashboardService();

export default function SuprimentosDashboard() {

    const [gastosPorProduto, setGastosPorProduto] = useState<ChartPieModel>({ title: "", pieces: [] })
    const [gastosPorMes, setGastosPorMes] = useState<ChartBarModel>({ title: "", nameX:"", nameY: "", bars: [] })

    useEffect(() => {
        suprimentosDashboardService.buscarChartPorProduto().then((gastosPorMes) => setGastosPorProduto(gastosPorMes)).catch((err) => console.error(err))
        suprimentosDashboardService.buscarChartPorMes().then((gastosPorMes) => setGastosPorMes(gastosPorMes)).catch((err) => console.error(err))
    }, [])

    const atalho = (nome: string, rota: string, imagem: string) => {
        return (
            <Link to={rota} style={{ textDecoration: "none" }} >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-around", width: 150, height: 150, backgroundColor: "#FFF", boxShadow: '3px 3px 10px 1px rgba(0,0,0,0.2)', borderRadius: 10, margin: 10 }} >

                    <img src={imagem} width={75} alt="" />
                    <span style={{ fontSize: 14, fontWeight: 500, color: "#303030" }}>{nome}</span>

                </div>
            </Link>
        )
    }

    return (
        <>
            <h2 style={{ fontSize: 20, fontWeight: 700, marginLeft: 8 }}>Atalhos</h2>
            <div style={{ display: "flex", columnGap: 30 }}>
                {atalho("Novo produto", "/produto/cadastrar", "/imagens/darkgrey/cadastros.png")}
                {atalho("Nota Fiscal Entrada", "/notaFiscalEntrada/cadastrar", "/imagens/darkgrey/suprimentos.png")}
                {atalho("Consulta de estoque", "/estoque", "/imagens/darkgrey/suprimentos.png")}
            </div>

            <h2 style={{ fontSize: 20, fontWeight: 700, marginLeft: 8, marginTop: 32 }}>Gráficos</h2>
            <div style={{ display: "flex", columnGap: 30 }}>
                <div style={{ width: 540, padding: 20, boxSizing: "border-box", borderRadius: 10, alignItems: 'center', backgroundColor: "#FFF", boxShadow: '3px 3px 10px 1px rgba(0,0,0,0.2)' }}>
                    <p style={{ fontSize: 18, fontWeight: 500, color: "#777" }} >{gastosPorProduto.title}</p>

                    <ChartPie width={500} height={250} data={gastosPorProduto} moneyFormat />
                </div>
                <div style={{ width: 540, padding: 20, boxSizing: "border-box", borderRadius: 10, alignItems: 'center', backgroundColor: "#FFF", boxShadow: '3px 3px 10px 1px rgba(0,0,0,0.2)' }}>
                    <p style={{ fontSize: 18, fontWeight: 500, color: "#777" }} >{gastosPorMes.title}</p>

                    <ChartBar width={500} height={250} data={gastosPorMes} showTitle={false} />
                </div>
            </div>
        </>
    )
}